export default __webpack_public_path__ + "static/attribute1-dark-5ed977b10ec656c0a2c61c464a3e933d.png";